import { Button, Modal } from 'antd';
import React, { FC } from 'react';

import { openNotification } from '../../../common/helpers';
import { NotificationTypes } from '../../../common/interfaces';
import { RangePicker } from '../../../components/RangePicker';
import { TitleModal } from '../../../components/TitleModal';
import { ordersApi } from '../../../store/api/orders.api';
import { downloadFile } from '../../Registration/Documents/Documents.helpers';
import styles from './ModalReport.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ModalReport: FC<Props> = ({ isOpen, onClose }) => {
  const [period, setPeriod] = React.useState<{
    dateBeg: string;
    dateEnd: string;
  }>({
    dateBeg: '',
    dateEnd: '',
  });

  // Получение файла по ID
  const [getReport, { isLoading: isLoadingReport }] =
    ordersApi.useGetReportMutation();

  const handleChangePeriod = (date: any, dateString: any) => {
    setPeriod({
      dateBeg: dateString[0],
      dateEnd: dateString[1],
    });
  };

  const onReset = () => {
    setPeriod({
      dateBeg: '',
      dateEnd: '',
    });
  };

  const onCloseModal = () => {
    onReset();
    onClose();
  };

  const onSubmit = async () => {
    if (!period.dateBeg || !period.dateEnd) {
      openNotification(NotificationTypes.ERROR, `Выберете период`);
      return;
    }

    try {
      const res = await getReport(period).unwrap();
      downloadFile(res);
    } catch (e) {
      openNotification(
        NotificationTypes.ERROR,
        `Произошла ошибка при загрузке отчета: ${e}`,
      );
    }
  };

  return (
    <Modal
      destroyOnClose
      footer={null}
      onCancel={onCloseModal}
      title={<TitleModal>Формирование отчета за период</TitleModal>}
      open={isOpen}
    >
      <div className={styles['range-picker']}>
        <RangePicker
          onReset={onReset}
          onChange={handleChangePeriod}
          size="large"
          style={{ width: '100%' }}
          format="DD.MM.YYYY"
          placeholder={['Начало периода', 'Конец периода']}
        />
      </div>

      <div className={styles.buttons}>
        <Button htmlType="button" size="large" key="back" onClick={onClose}>
          Отмена
        </Button>

        <Button 
          size="large"
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isLoadingReport}
          onClick={onSubmit}
        >
          Сформировать
        </Button>
      </div>
    </Modal>
  );
};
